var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AccordionContainer",
    {
      style: { backgroundColor: _vm.$themeTokens.surface },
      attrs: { hideTopActions: true, items: _vm.sections },
    },
    _vm._l(_vm.sections, function (section, index) {
      return _c("AccordionItem", {
        key: `section-questions-${index}`,
        attrs: {
          id: `section-questions-${index}`,
          title: _vm.displaySectionTitle(section, index),
        },
        on: {
          focus: function ($event) {
            return _vm.expand(index)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "heading",
              fn: function ({ title }) {
                return [
                  _c(
                    "h3",
                    {
                      staticClass: "accordion-header",
                      style:
                        index === _vm.currentSectionIndex &&
                        !_vm.isExpanded(index)
                          ? { border: `2px solid ${_vm.$themeTokens.primary}` }
                          : {},
                    },
                    [
                      _c(
                        "KButton",
                        {
                          staticClass: "accordion-header-label",
                          style: _vm.accordionStyleOverrides,
                          attrs: {
                            tabindex: "0",
                            appearance: "basic-link",
                            "aria-expanded": _vm.isExpanded(index),
                            "aria-controls": `section-question-panel-${index}`,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggle(index)
                            },
                          },
                        },
                        [
                          _c("KIcon", {
                            staticClass: "dot",
                            attrs: {
                              icon: _vm.sectionQuestionsIcon(index),
                              color: _vm.sectionQuestionsIconColor(index),
                            },
                          }),
                          _c("span", [_vm._v(_vm._s(title))]),
                          _c("KIcon", {
                            staticClass: "chevron-icon",
                            attrs: {
                              icon: _vm.isExpanded(index)
                                ? "chevronUp"
                                : "chevronRight",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "content",
              fn: function () {
                return [
                  _vm.isExpanded(index)
                    ? _c(
                        "div",
                        {
                          staticClass: "spacing-items",
                          style: {
                            backgroundColor: _vm.$themePalette.grey.v_200,
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "divider",
                            style: {
                              borderTop: `solid 1px ${_vm.$themeTokens.fineLine}`,
                            },
                          }),
                          _c(
                            "div",
                            {
                              attrs: {
                                "aria-label": _vm.jumpToQuestion$(),
                                role: "navigation",
                              },
                            },
                            [
                              _c(
                                "ul",
                                { staticClass: "history-list" },
                                _vm._l(
                                  section.questions,
                                  function (question, qIndex) {
                                    return _c(
                                      "li",
                                      {
                                        key: _vm.itemRef(question.item),
                                        ref: _vm.itemRef(question.item),
                                        refInFor: true,
                                        staticClass: "list-item",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "clickable",
                                            class: _vm.buttonClass(
                                              question.item
                                            ),
                                            attrs: {
                                              disabled:
                                                question.item ===
                                                _vm.questionItem,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$emit(
                                                  "goToQuestion",
                                                  section.startQuestionNumber +
                                                    qIndex
                                                )
                                              },
                                            },
                                          },
                                          [
                                            question.missing
                                              ? _c("KIcon", {
                                                  staticClass: "dot",
                                                  attrs: {
                                                    icon: "warning",
                                                    color:
                                                      _vm.$themePalette.yellow
                                                        .v_600,
                                                  },
                                                })
                                              : _c("KIcon", {
                                                  staticClass: "dot",
                                                  attrs: {
                                                    icon: _vm.isAnswered(
                                                      question
                                                    )
                                                      ? "unpublishedResource"
                                                      : "unpublishedChange",
                                                    color: _vm.isAnswered(
                                                      question
                                                    )
                                                      ? _vm.$themeTokens
                                                          .progress
                                                      : _vm.$themeTokens
                                                          .textDisabled,
                                                  },
                                                }),
                                            _c("div", { staticClass: "text" }, [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.questionText(
                                                      section.startQuestionNumber +
                                                        qIndex +
                                                        1
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }